import React from "react";
import classnames from "classnames";
import {useAppState} from "@core-ui/app-state-provider";
import {IShowPercentageOffProps, IShowPercentageOffTextProps} from "../types";

export const ShowPercentageOff = ({
  show,
  additionalClass,
  percentage,
}: IShowPercentageOffProps) => {
  const hasPercentageOff = percentage !== null && percentage !== 0;

  if (hasPercentageOff && show) {
    return (
      <span
        className={classnames("product-price__percentage-off", additionalClass)}
      >
        {`${percentage}% off`}
      </span>
    );
  }

  return null;
};

ShowPercentageOff.defaultProps = {
  percentage: 0,
};

export const ShowPercentageOffText = ({
  show,
  additionalClass,
  percentageOffText,
}: IShowPercentageOffTextProps) => {
  const {locale, brandName} = useAppState();

  const isBR_US = brandName === "br" && locale === "en_US";
  const hasPercentageOff =
    typeof percentageOffText === "string" &&
    !["0% off", "0"].includes(percentageOffText);
  if (hasPercentageOff && show && !isBR_US) {
    return (
      <span
        className={classnames("product-price__percentage-off", additionalClass)}
      >
        {percentageOffText}
      </span>
    );
  }

  return null;
};

ShowPercentageOffText.defaultProps = {
  additionalClass: "",
  percentageOffText: "0",
};
